import { Typography } from '@mui/material';

const statusBarColor = (status: string) => {
  if (status === 'pending') {
    return '#F09316';
  }

  if (status === 'approved') {
    return '#326295';
  }

  if (status === 'change') {
    return '#FFAF0F';
  }

  if (status === 'rejected') {
    return '#8A1A67';
  }

  if (status === 'cancelled') {
    return '#E9E9EA';
  }

  if (status === 'review_quote') {
    return '#00AEEF';
  }

  if (status === 'archived') {
    return '#43464A';
  }
};

const StatusPill: React.FC<{ status: string }> = ({ status }) => {
  const classes = {
    statusBar: {
      borderRadius: '8px',
      // color: status === 'archived' || status === 'rejected' ? '#FFF' : '#000',
      color: '#FFF',
      textTransform: 'capitalize',
      padding: '9.5px 16px 6.5px 16px',
      fontSize: '16px',
      display: 'inline-block',
    },
  };

  return (
    <Typography variant="h5" sx={[classes.statusBar, { backgroundColor: statusBarColor(status) }]}>
      {status === 'pending' && 'Pending'}
      {status === 'approved' && 'Approved'}
      {status === 'change' && 'Change Required'}
      {status === 'rejected' && 'Rejected'}
      {status === 'cancelled' && 'Cancelled'}
      {status === 'review_quote' && 'Review'}
      {status === 'archived' && 'Archived'}
    </Typography>
  );
};

export default StatusPill;
